import React, { createContext, ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import config from 'src/config';

const AnalyticsContext = createContext<null>(null);

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
}) => {
  return (
    <PostHogProvider
      apiKey={config.posthogApiKey}
      options={{
        api_host: config.posthogApiHost,
        autocapture: true, // Enable automatic event capture
        capture_exceptions: false, // right now sentry is handling exceptions
        debug: config.isDev,
      }}
    >
      <AnalyticsContext.Provider value={null}>
        {children}
      </AnalyticsContext.Provider>
    </PostHogProvider>
  );
};
